import React, { Suspense, useEffect } from 'react';
import GlobalStyle from './global-styles';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import { adminRoot } from './constants/defaultValues';
import ProtectedRoute from './helper/authHelper';
import { UserRole } from './helper/Utils';
import setAuthToken from './helper/setAuthToken';
import { hasValidToken, clearAuthData } from './helper/tokenUtils';
import store from './store';
import { LOGOUT } from './Container/Login/constants';
import { loadUser } from './Container/Login/actions';
import AuthGuard from './Components/AuthGuard';


const ViewHome = React.lazy(() =>
  import('./Views/home')
);
const ViewApp = React.lazy(() =>
  import('./Views/app/')
);
const ViewAdmin = React.lazy(() =>
  import('./Views/admin')
);
const ViewError = React.lazy(() =>
  import('./Views/error')
);
const ViewUnauthorized = React.lazy(() =>
  import('./Views/unauthorized')
);
const ViewSuccess = React.lazy(() =>
  import('./Views/success')
);

const App = () => {
  useEffect(() => {
    // Check for valid token on app load/refresh
    if (hasValidToken()) {
      setAuthToken(localStorage.token);
      store.dispatch(loadUser());
    } else {
      // Clear any invalid/expired token
      clearAuthData();
      store.dispatch({ type: LOGOUT });
    }
    
    // Log user out from all tabs if they log out in one tab
    const handleStorageChange = (e) => {
      if (e.key === 'token' && !e.newValue) {
        store.dispatch({ type: LOGOUT });
      }
    };
    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
  return (
    <div className="h-100">
      <Router>
        <AuthGuard>
          <Suspense fallback={<div className="loading" />}>
            <Switch>
              <Redirect exact from={`/`} to={`/admin`} />
              <ProtectedRoute
                path={adminRoot}
                component={ViewApp}
                roles={[
                  UserRole.superAdmin,
                  UserRole.admin,
                  UserRole.editor,
                  UserRole.member,
                  UserRole.electrical,
                  UserRole.assembly,
                  UserRole.PRODUCTION_ADMIN,
                  UserRole.ELECTRICAL_ADMIN,
                  UserRole.FIRMWARE_ADMIN
                ]}
              />
              <Route
                path="/admin"
                render={(props) => <ViewAdmin {...props} />}
              />
              <Route
                path="/error"
                exact
                render={(props) => <ViewError {...props} />}
              />
              <Route
                path="/success"
                exact
                render={(props) => <ViewSuccess {...props} />}
              />
              <Route
                path="/unauthorized"
                exact
                render={(props) => <ViewUnauthorized {...props} />}
              />
              <Route
                path="/"
                exact
                render={(props) => <ViewHome {...props} />}
              />
              <Redirect to="/error" />
            </Switch>
          </Suspense>
        </AuthGuard>
      </Router>
      <GlobalStyle />
    </div>
  );
}

export default App;
